import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Allineato a teatrocolosseo-api/lib/password.js */
export const PASSWORD_MIN = 12;

export function strongPasswordValidator(usernameCtrlName?: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const p = String(control.value ?? '');
    if (!p) return null;
    const need: string[] = [];
    if (p.length < PASSWORD_MIN) need.push(`min${PASSWORD_MIN}`);
    if (!/[a-z]/.test(p)) need.push('lower');
    if (!/[A-Z]/.test(p)) need.push('upper');
    if (!/[0-9]/.test(p)) need.push('digit');
    if (!/[^A-Za-z0-9]/.test(p)) need.push('special');
    if (usernameCtrlName) {
      const u = String(control.parent?.get(usernameCtrlName)?.value ?? '');
      if (u.length >= 3 && p.toLowerCase().includes(u.toLowerCase())) need.push('username');
    }
    return need.length ? { strongPassword: need } : null;
  };
}

export function passwordMatchValidator(passwordKey = 'password', confirmKey = 'confirm_password'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const a = control.get(passwordKey)?.value;
    const b = control.get(confirmKey)?.value;
    if (a == null && b == null) return null;
    if (!a && !b) return null;
    return a === b ? null : { mismatch: true };
  };
}

export const PASSWORD_HINT =
  `Min. ${PASSWORD_MIN} caratteri, con maiuscola, minuscola, cifra e carattere speciale.`;
